import { render, staticRenderFns } from "./ClassesDetailTeachers.vue?vue&type=template&id=6177226f&scoped=true&"
import script from "./ClassesDetailTeachers.vue?vue&type=script&lang=js&"
export * from "./ClassesDetailTeachers.vue?vue&type=script&lang=js&"
import style0 from "./ClassesDetailTeachers.vue?vue&type=style&index=0&id=6177226f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6177226f",
  null
  
)

export default component.exports